import {connect} from 'react-redux';

import {AppState} from '../../../../../../../../../src/store/appState';
import {makeGetAccount} from '../../../../../../../../../src/store/data/accounts/accountsSelectors';
import {popoutContactDetailsAction} from '../../../../../../../../../src/store/panels/contacts/contactDetailsPanelActions';
import {ContactsManagerPanelId} from '../../../../../../../../../src/store/panels/panelStateBase';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../../srcCommon/helpers/reselectHelpers';
import {AccountsTableRow} from './accountsTableRow';

/*
 * Props.
 */

interface AccountsTableRowContainerProps {
  panelId: ContactsManagerPanelId;
  accountId: number;
}

/*
 * Selectors.
 */

function getAccountId(_state: AppState, props: AccountsTableRowContainerProps) {
  return props.accountId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AccountsTableRowContainerProps>()(() => {
  const getAccount = makeGetAccount(getAccountId);
  return {
    account: getAccount,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<AccountsTableRowContainerProps>()(() => ({
  popoutContactDetails: popoutContactDetailsAction,
}));

export const AccountsTableRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const {popoutContactDetails} = dispatchProps;
    return {
      ...ownProps,
      ...stateProps,
      openTeammateContactDetailsPopUp: (contactUid?: string) => {
        popoutContactDetails({
          parentPanelId: ownProps.panelId,
          selectedContactUid: contactUid,
          shouldFetchContact: true,
          shouldHideHeaderTabs: true,
        });
      },
    };
  },
)(AccountsTableRow);
